import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CmsService, WindowRef } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, combineLatest } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CustomInfoBoxesData } from './custom-info-boxes.model';

@Component({
  selector: 'app-custom-info-boxes',
  templateUrl: './custom-info-boxes.component.html',
  styleUrls: ['./custom-info-boxes.component.scss'],
  standalone: false
})
export class CustomInfoBoxesComponent implements OnInit, AfterViewInit {
  constructor(
    private componentData: CmsComponentData<CustomInfoBoxesData>,
    private cmsService: CmsService,
    private winRef: WindowRef,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  data$ = this.componentData.data$.pipe(map(component => component));
  items$: Observable<any[]> = this.componentData.data$.pipe(
    switchMap(data =>
      combineLatest(
        data.items?.trim().split(' ').map((codes: any) => this.cmsService.getComponentData(codes).pipe(
          map(tab => tab)
        )))
    ));

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    if (this.winRef.localStorage?.professionalElement === 'chefsarea-professional') {
      const body = this.winRef.document.body;
      body.classList.add('no-scroll');
      const targetEl = this.winRef.document.getElementById('chefsarea-professional');
      const yOffset = -100;
      if (targetEl) {
        this.winRef.localStorage.setItem('isProfessional', 'true');
        if (isPlatformBrowser(this.platformId)) {
          setTimeout(function () {
            const y = targetEl.getBoundingClientRect().top + this.winRef.nativeWindow.pageYOffset + yOffset;
            targetEl.scrollIntoView({ behavior: 'smooth' });
            this.winRef.nativeWindow.scrollTo({ top: y });
          }, 900);
        }
      }
      if (isPlatformBrowser(this.platformId)) {
        setTimeout(function () {
          this.winRef?.localStorage?.removeItem('professionalElement');
          body.classList.remove('no-scroll');
        }, 900);
      }
    }
  }
}
